import { useMutation } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  InitiatePaymentProofExtractionRequestSchema,
  InitiatePaymentProofExtractionRequestType,
  InitiatePaymentProofExtractionResponseSchema,
  InitiatePaymentProofExtractionResponseType
} from '../../../services/NwExternalPaymentsServices/APIService/types';

import { useNwExternalPaymentsService } from '../useNwExternalPaymentsService';

interface UseInitiatePaymentProofExtractionApiInterface {
  initiatePaymentProofExtractionApi: (
    input: InitiatePaymentProofExtractionRequestType
  ) => Promise<InitiatePaymentProofExtractionResponseType>;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: 'idle' | 'loading' | 'success' | 'error';
  reset: () => void;
}

const useInitiatePaymentProofExtractionApi =
  (): UseInitiatePaymentProofExtractionApiInterface => {
    const { nwExternalPaymentsServiceInstance } = useNwExternalPaymentsService();

    const initiatePaymentProofExtraction = (
      requestObject: InitiatePaymentProofExtractionRequestType
    ) => {
      try {
        InitiatePaymentProofExtractionRequestSchema.parse(requestObject);
      } catch (error) {
        console.error('Invalid request object:', error);
        throw error;
      }

      return nwExternalPaymentsServiceInstance
        .initiatePaymentProofExtraction(requestObject)
        .then((response) => {
          try {
            InitiatePaymentProofExtractionResponseSchema.parse(response);
          } catch (error) {
            console.error('Invalid response object:', error);
            throw error;
          }
          return response;
        });
    };

    const { mutateAsync, isLoading, isError, error, status, reset } = useMutation(
      initiatePaymentProofExtraction,
      {
        mutationKey: ['initiatePaymentProofExtractionApi']
      }
    );

    return {
      initiatePaymentProofExtractionApi: mutateAsync,
      isLoading,
      isError,
      error: error ? getAPIErrorMessage(error) : null,
      status,
      reset
    };
  };

export { useInitiatePaymentProofExtractionApi };
